// extracted by mini-css-extract-plugin
export default {"container":"Header_container__x7WnB","clearButton":"Header_clearButton__FDBYU"};